var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Row, Col } from 'reactstrap';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import BootstrapTheme from '@fullcalendar/bootstrap';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import { CollaboratorTicket, getAfiliateFromSale, PacketTicket, Ticket } from '../Model';
import { inject, observer } from 'mobx-react';
import Voucher from '../../Vouchers/Model';
import TicketRenderModal from './TicketRenderModal';
import VoucherDetail from './VoucherDetail';
import { T } from 'helpers/i18n';
import { getLocaleFullcalendar, toMoney } from '../../../helpers/Format';
import PacketTicketDetail from './PacketTicketDetail';
import { Range } from '../../DashboardTicket/Util/Mapea';
import { typeList } from '../Store';
import './CalendarSales.css';
import { tramoHora } from './TicketSales';
import { getQuantityFromLines, twoDigits } from '../../../helpers/Utils';
var CalendarSales = /** @class */ (function (_super) {
    __extends(CalendarSales, _super);
    function CalendarSales(args) {
        var _this = _super.call(this, args) || this;
        _this.calendarRef = React.createRef();
        _this.loaded = false;
        _this.handleToggle = function () {
            // this.setState({itemToRender: undefined, showDialog: false})
            _this.setState({ showDialog: false });
        };
        _this.reloadCalendar = function () {
            var api = _this.calendarRef.current.getApi();
            api.refetchEvents();
        };
        _this.handleRefunded = function () {
            _this.reloadCalendar();
        };
        _this.handleRebooked = function () {
            _this.reloadCalendar();
        };
        _this.handleEventMouseEnter = function (info) {
            // console.log('info: ', info.view)
            // console.log('info.event.extendedProps: ', info.event.extendedProps)
            if (!info.event.extendedProps.item)
                return;
            if (info.view.type === 'dayGridMonth') {
                // console.log('info: ', info.event.id)
                var el = info.el;
                var date = new Date(info.event.start);
                var content = void 0;
                if (info.event.extendedProps.item instanceof Voucher) {
                    var item = info.event.extendedProps.item;
                    content = (React.createElement(React.Fragment, null,
                        item ? item.display_id : '',
                        React.createElement("div", null, "".concat(date.getHours() > 9 ? date.getHours() : '0' + date.getHours(), ":").concat(date.getMinutes() > 9
                            ? date.getMinutes()
                            : '0' + date.getMinutes(), " ").concat(item.itemName))));
                }
                else {
                    var item = info.event.extendedProps.item;
                    if (item.tramoHora && item.hours && item.minutes) {
                        content = (React.createElement(React.Fragment, null,
                            item ? item.numberSI : item.numero,
                            React.createElement("div", null, "".concat(item.hours > 9 ? item.hours : '0' + item.hours, ":").concat(item.minutes > 9 ? item.minutes : '0' + item.minutes, " ").concat(item.stretchName))));
                    }
                    else {
                        content = (React.createElement(React.Fragment, null,
                            item ? item.numberSI : item.numero,
                            React.createElement("div", null, "".concat(item.stretchName))));
                    }
                }
                ReactDOM.render(content, el);
            }
        };
        _this.renderEvent = function (info) {
            // console.log('renderEvent - info: ', info)
            var el = info.el;
            var date = new Date(info.event.start);
            // const content = <div>{`${date.getHours()} ${date.getMinutes() !== 0 ? ':' + date.getMinutes() : ''} ${info.event.title}`}</div>
            var content;
            if (info.event.extendedProps.item instanceof Voucher) {
                var item = info.event.extendedProps.item;
                content = (React.createElement(React.Fragment, null,
                    item ? item.display_id : '',
                    React.createElement("div", null, "".concat(date.getHours() > 9 ? date.getHours() : '0' + date.getHours(), ":").concat(date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes(), " ").concat(item.itemName))));
            }
            else {
                var item = info.event.extendedProps.item;
                content = (React.createElement("div", { className: "fc-content" },
                    item.tramoHora && React.createElement("span", { className: "fc-time" }, "".concat(tramoHora(date, item.hours, item.minutes), " ")),
                    React.createElement("span", { className: "fc-title" }, "".concat(info.event.title))));
            }
            ReactDOM.render(content, el);
        };
        _this.renderEventListMonth = function (info) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            // console.log('renderEvent - info: ', info)
            var el = info.el;
            var date = new Date(info.event.start);
            // const content = <div>{`${date.getHours()} ${date.getMinutes() !== 0 ? ':' + date.getMinutes() : ''} ${info.event.title}`}</div>
            var content;
            if (info.event.extendedProps.item instanceof Voucher) {
                var item = info.event.extendedProps.item;
                var hours = void 0, minutes = void 0, contentHoursMinutes = void 0;
                hours = date.getHours();
                minutes = date.getMinutes();
                contentHoursMinutes = "".concat(twoDigits(hours), ":").concat(twoDigits(minutes));
                var collaboratorName = item.agent ? (JSON.parse(item.agent).name) : '';
                content = (React.createElement(React.Fragment, null,
                    React.createElement("td", { className: "fc-list-item-time fc-widget-content", style: styledCanceled(item.rebooked_to) }, contentHoursMinutes),
                    React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.rebooked_to) }, "".concat(item.pk)),
                    React.createElement("td", { className: "fc-list-item-marker fc-widget-content" },
                        React.createElement("span", { className: "fc-event-dot", style: {
                                backgroundColor: item.receipt_total - item.amount_paid > 0 ? 'red' : item.rebooked_to ? 'gray' : 'blue'
                            } })),
                    React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.rebooked_to) }, "".concat(item.itemName)),
                    React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: {
                            backgroundColor: item.receipt_total - item.amount_paid > 0 ? 'red' : 'inherit',
                            color: item.receipt_total - item.amount_paid > 0 ? 'white' : 'inherit'
                        } }, "".concat(item.receipt_total - item.amount_paid > 0 ? toMoney((item.receipt_total - item.amount_paid) / 100, item.currency.toUpperCase()) : '')),
                    React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.rebooked_to) }, "".concat(getQuantityFromLines(item.lines), " pax")),
                    React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: __assign({ backgroundColor: item.affiliate_company ? '#ffcfa5' : undefined }, styledCanceled(item.rebooked_to)) }, item.affiliate_company ? item.affiliate_company.name : ''),
                    React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.rebooked_to) }, (_a = item.note) !== null && _a !== void 0 ? _a : ''),
                    React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.rebooked_to) }, collaboratorName),
                    (item.contactName) &&
                        React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.rebooked_to) }, item.contactName)));
            }
            else {
                var item = info.event.extendedProps.item;
                if (item instanceof Ticket) {
                    var collaboratorName = void 0;
                    var isFromPacket = !!item.packetTicket_id;
                    if (item instanceof CollaboratorTicket) {
                        collaboratorName = "".concat(T('collaborator'), ": ").concat(item.collaboratorName);
                    }
                    var afiliate = getAfiliateFromSale(item);
                    var afiliateName = afiliate ? afiliate.afiliateName : '';
                    var hours = void 0, minutes = void 0, contentHoursMinutes = void 0;
                    if (item.hours >= 0 && item.hours !== null && item.minutes >= 0 && item.minutes !== null) {
                        hours = item.hours;
                        minutes = item.minutes;
                        contentHoursMinutes = "".concat(twoDigits(hours), ":").concat(twoDigits(minutes));
                    }
                    else {
                        if (item.tramoHora) {
                            var datebook = new Date(item.datebook);
                            hours = datebook.getHours();
                            minutes = datebook.getMinutes();
                            contentHoursMinutes = "".concat(twoDigits(hours), ":").concat(twoDigits(minutes));
                        }
                        else {
                            contentHoursMinutes = '--:--'; // T('customized')
                        }
                    }
                    content = React.createElement("div", { style: { backgroundColor: isFromPacket ? 'green' : 'inherit', color: isFromPacket ? 'white' : 'inherit' } },
                        React.createElement("td", { className: "fc-list-item-time fc-widget-content", style: styledCanceled(item.daterefund) }, contentHoursMinutes),
                        React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.daterefund) }, "".concat(item.id)),
                        React.createElement("td", { className: "fc-list-item-marker fc-widget-content" },
                            React.createElement("span", { className: "fc-event-dot", style: {
                                    backgroundColor: item.totalDue > 0 ? 'red' : item.refund_id ? 'gray' : 'blue'
                                } })),
                        React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: __assign(__assign({}, styledCanceled(item.daterefund)), { width: '250px' }) }, "".concat(item.operationLineName, " - ").concat(item.stretchName)),
                        React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: {
                                backgroundColor: item.totalDue > 0 ? 'red' : 'inherit',
                                color: item.totalDue > 0 ? 'white' : 'inherit'
                            } }, "".concat(item.totalDue > 0 ? toMoney(item.totalDue, item.money) : '')),
                        React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.daterefund) }, "".concat(getQuantityFromLines(item.lines), " pax")),
                        React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: __assign({ backgroundColor: afiliateName ? '#ffcfa5' : undefined }, styledCanceled(item.daterefund)) }, afiliateName !== null && afiliateName !== void 0 ? afiliateName : ''),
                        React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.daterefund) }, (_b = item.additionalNote) !== null && _b !== void 0 ? _b : ''),
                        React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.daterefund) }, collaboratorName !== null && collaboratorName !== void 0 ? collaboratorName : ''),
                        (((_c = item.contact) === null || _c === void 0 ? void 0 : _c.name) || ((_d = item.contact) === null || _d === void 0 ? void 0 : _d.surname)) &&
                            React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.daterefund) },
                                item.contact.name,
                                " ",
                                item.contact.surname),
                        ((_e = item.contact) === null || _e === void 0 ? void 0 : _e.pickUpLocations) &&
                            React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.daterefund) },
                                "P.U:: ",
                                item.contact.pickUpLocations,
                                " "),
                        ((_f = item.contact) === null || _f === void 0 ? void 0 : _f.dropOffLocations) &&
                            React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.daterefund) },
                                "D.O: ",
                                item.contact.dropOffLocations,
                                " "),
                        ((_g = item.contact) === null || _g === void 0 ? void 0 : _g.flightInfo) &&
                            React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.daterefund) },
                                "FL: ",
                                item.contact.flightInfo,
                                " "),
                        ((_h = item.contact) === null || _h === void 0 ? void 0 : _h.additionalInformation) &&
                            React.createElement("td", { className: "fc-list-item-title fc-widget-content", style: styledCanceled(item.daterefund) }, item.contact.additionalInformation));
                }
            }
            ReactDOM.render(content, el);
        };
        _this.handleEventMouseLeave = function (info) {
            // console.log('info: ', info.view.type)
            if (!info.event.extendedProps.item)
                return;
            if (info.view.type === 'dayGridMonth') {
                _this.renderEvent(info);
            }
        };
        _this.handleEventClick = function (info) {
            _this.ticketToRender = info.event.extendedProps.item;
            // console.log('this.ticketToRender', this.ticketToRender)
            _this.setState({ showDialog: true });
        };
        _this.handleEvents = function (fetchInfo, success, failure) {
            // console.log('handleEvents')
            // cada vez que se pulsa en prev next se llama esta función y el primer render
            if (_this.fetchInfo && (fetchInfo.startStr === _this.fetchInfo.startStr && fetchInfo.endStr === _this.fetchInfo.endStr)) {
                // return
            }
            _this.fetchInfo = fetchInfo;
            _this.props.store.dashboardTicket
                .calendarReport(Range.Custom, typeList.Calendar, fetchInfo.start, fetchInfo.end)
                .then(function (result) {
                var mapeados = _this.mapeaEventos(result);
                success(mapeados);
            })
                .catch(function (error) {
                console.log('CalendarioSales - failure - error: ', error);
                failure(error);
            });
        };
        _this.mapeaEventos = function (items) {
            // console.log('items: ', items.packetTickets)
            // console.log('vouchers: ', items.vouchers)
            var _a;
            var ticketsFromPackets = items.packetTickets
                .filter(function (pt) { return !pt.refund_id; })
                .reduce(function (previousValue, currentValue) {
                var tickets = currentValue.tickets.map(function (value) { return new Ticket(value); });
                previousValue.push.apply(previousValue, tickets);
                return previousValue;
            }, []);
            // console.log('ticketsFromPackets: ', ticketsFromPackets)
            // console.log('antes items.tickets.length: ', items.tickets.length)
            // console.log('antes items.tickets: ', items.tickets)
            // ticketsFromPackets.forEach(tfp => items.tickets.push(tfp))
            (_a = items.tickets).push.apply(_a, ticketsFromPackets);
            // console.log('después items.tickets.length: ', items.tickets.length)
            // console.log('después items.tickets: ', items.tickets)
            var resultTickets = items.tickets
                .filter(function (ticket) { return !ticket.refund_id; })
                .map(function (ticket) {
                var _a, _b, _c, _d, _e, _f;
                var start;
                var _datebook = (_a = ticket.datebookNTZ) !== null && _a !== void 0 ? _a : ticket.datebook;
                start = new Date((_b = ticket.year) !== null && _b !== void 0 ? _b : _datebook.getFullYear(), (_c = ticket.month) !== null && _c !== void 0 ? _c : _datebook.getMonth(), (_d = ticket.day) !== null && _d !== void 0 ? _d : _datebook.getDate(), (_e = ticket.hours) !== null && _e !== void 0 ? _e : 0, (_f = ticket.minutes) !== null && _f !== void 0 ? _f : 0, 0, 0);
                var evento = {
                    id: ticket.numero,
                    title: ticket.operationLineName + ' - ' + ticket.stretchName,
                    start: start,
                    // className: ticket.daterefund || ticket.refund_id? 'bg-gray-100' : 'inherited',
                    backgroundColor: ticket.daterefund || ticket.refund_id ? '#f0f3f5' : undefined,
                    textColor: ticket.daterefund || ticket.refund_id ? 'black' : 'white',
                    extendedProps: {
                        item: ticket
                    }
                };
                if (ticket.daterefund || ticket.refund_id) {
                    evento.extendedProps.status = 'canceled';
                }
                else if (ticket.datevalited) {
                    evento.extendedProps.status = 'valited';
                }
                return evento;
            });
            var resultCollaboratorOperatorTickets = items.collaboratorOperatorTickets
                .filter(function (ticket) { return !ticket.refund_id && !ticket.packetTicket_id; })
                .map(function (ticket) {
                var evento = {
                    id: ticket.numero,
                    title: ticket.collaboratorName +
                        ' ' +
                        ticket.operationLineName +
                        ' ' +
                        ticket.stretchName,
                    start: new Date(ticket.datebook),
                    className: ticket.daterefund || ticket.refund_id ? 'bg-gray-100' : 'bg-orange',
                    extendedProps: {
                        item: ticket
                    }
                };
                return evento;
            });
            var resultVoucher = items.vouchers.map(function (voucher) {
                var paid = voucher.amount_paid === voucher.receipt_total;
                var evento = {
                    id: voucher.confirmation_url,
                    title: voucher.itemName,
                    className: paid ? 'bg-green' : 'bg-red',
                    start: new Date(voucher.start_at),
                    extendedProps: {
                        item: voucher
                    }
                };
                // asignamos status: puede ser booked, rebooked, cancelled, (quizás falte cuando se validen todos los pasajeros)
                if (voucher.status === 'cancelled') {
                    evento.extendedProps.status = 'cancelled';
                }
                else if (voucher.status === 'rebooked') {
                    // ????
                }
                else {
                    // booked
                    var numberValited_1 = 0;
                    var numberLines = voucher.lines.length;
                    voucher.lines.forEach(function (line) {
                        if (line.chekin_status === 'checked-in') {
                            numberValited_1++;
                        }
                    });
                    if (numberValited_1 === numberLines) {
                        evento.extendedProps.status = 'valited';
                    }
                    else {
                        evento.extendedProps.status = 'booked';
                    }
                }
                return evento;
            });
            var resultPacketTicket = items.packetTickets.map(function (packetTicket) {
                var evento = {
                    id: packetTicket.numero,
                    title: packetTicket.packetName,
                    start: new Date(packetTicket.datebook),
                    extendedProps: {
                        item: packetTicket
                    },
                    className: 'bg-green'
                };
                return evento;
            });
            var result = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], resultTickets, true), resultVoucher, true), resultPacketTicket, true), resultCollaboratorOperatorTickets, true);
            return result;
        };
        _this.handleLoading = function (isLoading) {
            // console.log('isLoading: ', isLoading)
        };
        _this.handleSucess = function (info) {
            // console.log('handleSucess info: ', info)
        };
        _this.handleDateClic = function (arg) {
            var api = _this.calendarRef.current.getApi();
            api.changeView('timeGridOneDay', arg.dateStr);
        };
        // this.state = {events: [], showDialog: false, itemToRender: undefined, tickets: [], count: 0}
        _this.state = { showDialog: false };
        return _this;
    }
    CalendarSales.prototype.render = function () {
        var _this = this;
        // console.log('CalendarSales - render - this.ticketToRender: ', this.ticketToRender)
        // const {itemToRender, showDialog, count} = this.state
        var showDialog = this.state.showDialog;
        // console.log('CalendarSales - render - showDialog: ', showDialog)
        var ticketToRender = this.ticketToRender;
        // console.log('locale - langAndRegion: ', langAndRegion)
        var locale = getLocaleFullcalendar();
        return (React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Col, { className: "col-12" },
                    React.createElement(FullCalendar, { views: {
                            timeGridOneDay: {
                                type: 'listWeek',
                                duration: { days: 1 },
                                buttonText: T('day')
                            }
                        }, dateClick: this.handleDateClic, eventSourceSuccess: this.handleSucess, loading: this.handleLoading, ref: this.calendarRef, height: 'auto', locale: locale, firstDay: 1, defaultView: 'listMonth', plugins: [BootstrapTheme, dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin], slotDuration: '00:15:00', 
                        /*minTime={'08:00:00'}
                        maxTime={'19:00:00'}*/
                        /*themeSystem={'bootstrap'}*/
                        /*themeSystem={'standard'}*/
                        handleWindowResize: true, bootstrapFontAwesome: false, buttonText: {
                            // today: `${T('today')}`,
                            // month: `${T('calendarMonth')}`, 
                            // week: `${T('week')}`, 
                            prev: T('previous'),
                            next: T('following'),
                        }, header: {
                            left: 'prev,next, today',
                            center: 'title',
                            /*right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'*/
                            // right: 'dayGridMonth,timeGridDay,listMonth'
                            // right: 'dayGridMonth, timeGridOneDay'
                            right: 'dayGridMonth, listMonth' // , timeGridOneDay'
                            // right: 'dayGridMonth, timeGridMonth, timeGridOneDay'
                        }, droppable: false, editable: false, eventLimit: true, selectable: true, events: this.handleEvents, 
                        /*eventSources={[
                          sources
                        ]}*/
                        eventClick: this.handleEventClick, eventMouseEnter: this.handleEventMouseEnter, eventMouseLeave: this.handleEventMouseLeave, 
                        /*eventPositioned={this.handleEventPositioned}*/
                        eventRender: function (info) {
                            // console.log('eventRender info.view.type: ', info.view.type)
                            if (!info.event.extendedProps.item)
                                return;
                            if (info.view.type === 'dayGridMonth') {
                                _this.renderEvent(info);
                            }
                            else if (info.view.type === 'listMonth' || info.view.type === 'listWeek' || info.view.type === 'timeGridOneDay') {
                                _this.renderEventListMonth(info);
                            }
                            if (info.event.extendedProps.status === 'cancelled') {
                                var el = info.el.getElementsByClassName('fc-list-item')[0];
                                // console.log('el: ', el)
                                // Change color of dot marker
                                var dotEl = info.el.getElementsByClassName('fc-event-dot')[0];
                                if (dotEl) {
                                    dotEl.style.backgroundColor = 'red';
                                }
                            }
                            else if (info.event.extendedProps.status === 'valited') {
                                var el = info.el.getElementsByClassName('fc-list-item')[0];
                                // console.log('el: ', el)
                                // Change color of dot marker
                                var dotEl = info.el.getElementsByClassName('fc-event-dot')[0];
                                if (dotEl) {
                                    dotEl.style.backgroundColor = 'black';
                                }
                            }
                        } }))),
            showDialog && React.createElement(RenderSale, { ticketToRender: ticketToRender, onToggle: this.handleToggle, onRefunded: this.handleRefunded, onRebooked: this.handleRebooked })));
    };
    CalendarSales = __decorate([
        inject('store'),
        observer
        /*@loading<Props>(props => [
          props.store!.dashboardTicket.calendarReport(Range.Month, typeList.Calendar) // .then(result => ({tickets: result.tickets, vouchers: result.vouchers}))
        ])*/
    ], CalendarSales);
    return CalendarSales;
}(Component));
export default CalendarSales;
var styledCanceled = function (canceled) { return ({ color: canceled ? 'red' : 'inherit' }); };
var RenderSale = function (props) {
    var ticketToRender = props.ticketToRender, onToggle = props.onToggle, onRefunded = props.onRefunded, onRebooked = props.onRebooked;
    if (!ticketToRender) {
        return null;
    }
    if (ticketToRender instanceof PacketTicket) {
        return (React.createElement(PacketTicketDetail, { item: ticketToRender, onToggle: onToggle }));
    }
    else if (ticketToRender instanceof Voucher) {
        return (React.createElement(VoucherDetail, { voucher: ticketToRender, onToggle: onToggle }));
    }
    else if (ticketToRender instanceof Ticket) {
        return (React.createElement(TicketRenderModal, { ticket: ticketToRender, onToggle: onToggle, onRefunded: onRefunded, onRebooked: onRebooked, originList: typeList.Calendar }));
    }
    return null;
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/CalendarSales.tsx
// module id = 1170
// module chunks = 0